<template>
  <div style="width: 4.5833rem;" class="animate__animated animate__fadein animate__delay-0.5s animate__slower">
    <transition name="el-fade-in-linear">
      <div v-if="type == '0'"
        style="box-shadow: 0 0 .1042rem rgba(0, 0, 0, .25);width:2rem;height: 2.5rem;position:fixed;z-index: 99 !important;background-color: white;top: .7rem;left: 4rem;">
        <!-- <img :src="this.imgurl" alt=""> -->
        <el-image :src="'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' + this.imgurl" alt="QR Code"
          style="width: 1rem;height: 1rem;margin-left:.5rem;margin-top: 0.5rem;">
          <div slot="placeholder">
            <!-- <el-spin indicator="el-icon-loading" size="40px"></el-spin> -->
            <div style="text-align: center;color: rgb(1, 162, 153);font-size: .1rem;margin-top: .5rem;">加载中...</div>
          </div>
        </el-image>
        <div style="margin-top: .2rem;margin-left: .7rem;font-size: .1rem;">微信扫码支付</div>
        <el-button type="success" style="margin-left: 2.7rem;margin-top: 0.3rem;" @click="chaxun">我已支付</el-button>
      </div>
    </transition>
    <img src="../../assets/close.png" @click="type = ''" v-if="type == '0'"
      style=" width: .0521rem;height: .0521rem;position:fixed;  z-index: 1000;left: 5.85rem;top: 0.78rem;" alt="">
    <img src="../../assets/Personback.png" alt=""
      style="width: .4167rem;height: .1458rem;position: relative; top: -0.2083rem;left: -0.2604rem;"
      @click="$router.push('/personteacher/renzheng')">
    <div class="bigtitle">认证说明</div>
    <div class="txt">
      <div class="span">1．在读大学生、研究生提供学生证，校园卡照片或学信网学历截图进行认证； </div>
      <div class="span">2．已毕业老师提供毕业证、学信网学历截图或工作证等进行认证；</div>
      <div class="span">3．教师资格证认证后对外会展示老师持有教师资格证，优先接单；</div>
      <div class="span">4．若上述资料都没法提供，可提供其他证明，证明老师优秀，有能力带好学生即可；</div>
      <div class="span">5．三类证件至少提供一个，方便后台进行审核；</div>
    </div>
    <div class="box">
      <div class="smalltitle">学生证（或毕业证）</div>
      <div class="line"></div>
      <el-upload class="upload-demo" drag action="/Api/Teacher/Honest" multiple :http-request="uploadEducation"
        :auto-upload="true" accept="image/jpg,image/png">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过10MB</div>
      </el-upload>
    </div>
    <div class="box">
      <div class="smalltitle">教师资格证</div>
      <div class="line"></div>
      <el-upload class="upload-demo" drag action="/Api/Teacher/Honest" multiple :http-request="qualification"
        :auto-upload="true" accept="image/jpg,image/png">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过10MB</div>
      </el-upload>
    </div>
    <div class="box">
      <div class="smalltitle">其他证明<span style="font-size: .0677rem;">（如获奖证书、四六级成绩证明等）</span>
      </div>
      <div class="line"></div>
      <el-upload class="upload-demo" drag action="/Api/Teacher/Honest" multiple :http-request="others"
        :auto-upload="true" accept="image/jpg,image/png">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过10MB</div>
      </el-upload>
    </div>
    <button @click="tijiao">提交资料</button>

  </div>
</template>

<script>
export default {
  methods: {
    uploadEducation(file) {
      let formData = new FormData();
      formData.append('uploadFile', file.file);
      this.$http.post('/Api/Teacher/Honest', formData, {
        headers: {
          'Authorization': this.Authorization,
          'Content-Type': 'application/form-data'
        }
      }).then(res => {
        this.info.education = res.data.data
      }).catch(err => {
        console.error(err);
      });
    },
    qualification(file) {
      let formData = new FormData();
      formData.append('uploadFile', file.file);
      this.$http.post('/Api/Teacher/Honest', formData, {
        headers: {
          'Authorization': this.Authorization,
          'Content-Type': 'application/form-data'
        }
      }).then(res => {
        this.info.qualification = res.data.data
      }).catch(err => {
        console.error(err);
      });
    },
    others(file) {
      let formData = new FormData();
      formData.append('uploadFile', file.file);
      this.$http.post('/Api/Teacher/Honest', formData, {
        headers: {
          'Authorization': this.Authorization,
          'Content-Type': 'application/form-data'
        }
      }).then(res => {
        this.info.others = res.data.data
      }).catch(err => {
        console.error(err);
      });
    },
    tijiao() {
      if (!this.info.education && !this.info.qualification && !this.info.others) {
        this.$message({
          message: '未填写任何资料',
          type: 'warning'
        });
      }
      else {
        this.type = '0'
        this.$http.get('/Api/Pay/snow', {
          headers: {
            'Authorization': localStorage.getItem('Authorization')
          }
        }).then(res => {
          console.log(res.data.data);
          console.log(res);
          this.orderId = res.data.data
          this.type = 0
          this.$http.post('/Api/Pay/web', {}, {
            params: {
              orderId: res.data.data,
              type: 0
            },
            headers: {
              'Authorization': localStorage.getItem('Authorization')
            }
          }).then(postres => {
            // console.log(postres);
            this.imgurl = postres.data.code_url
            // console.log(this.imgurl);
            this.ifpay()

          })
        })
      }

    },
    ifpay() {

      let timer = setInterval(() => {
        this.$http.post('/Api/Pay/check', {}, {
          params: {
            orderId: this.orderId,
            plate: 1
          },
          headers: {
            'Authorization': localStorage.getItem('Authorization')
          }
        }).then(res => {
          // console.log(res);
          if (res.data.data == true) {
            clearInterval(timer)
            clearTimeout(timer2)
            this.type = ''
            this.$message({
              type: 'success',
              message: '支付成功'
            });
            this.type = ''
            this.$http.put('/Api/Teacher/certificate', JSON.stringify(this.info), {
              headers: {
                'Authorization': localStorage.getItem('Authorization'),
                'Content-Type': 'application/json'
              }
            }).then(res => {
              console.log(res);
              this.$router.push('/personteacher/renzhengsucces')
            })
          }
        })
      }, 500)
      let timer2 = setTimeout(() => {
        clearInterval(timer)
        clearTimeout(timer2)
        this.type = ''
        this.$message({
          type: 'error',
          message: '支付超时'
        });
      }, 40000)
    }, chaxun() {

      this.$http.post('/Api/Pay/check', {}, {
        params: {
          orderId: this.orderId,
          plate: 1
        },
        headers: {
          'Authorization': localStorage.getItem('Authorization')
        }
      }).then(res => {
        console.log(res);

        if (res.data.data == true) {
          this.$message({
            type: 'success',
            message: '支付成功'
          });
          this.type = ''
          this.$http.put('/Api/Teacher/certificate', JSON.stringify(this.info), {
            headers: {
              'Authorization': localStorage.getItem('Authorization'),
              'Content-Type': 'application/json'
            }
          }).then(res => {
            console.log(res);
            this.$router.push('/personteacher/renzhengsucces')
          })
        }
        else {
          this.$message({
            type: 'error',
            message: '支付失败'
          });
          this.type = ''
          this.info.version = this.version
        }
      })
    }
  },
  data() {
    return {
      Authorization: '',
      info: {
        education: '',
        qualification: '',
        others: ''
      },
      type: '',
      imgurl: '',
      orderId: '',
      version: '',
    }
  },
  created() {
    this.Authorization = localStorage.getItem('Authorization')
    this.$http.get('/Api/Teacher', {
      headers: {
        'Authorization': localStorage.getItem('Authorization')
      }
    }).then(res => {
      console.log(res);
      this.version = res.data.data.version

    })

  }
}
</script>

<style scoped>
.bigtitle {
  /* 认证说明 */
  width: 96px;
  height: 34px;
  color: rgb(0, 0, 0);
  font-family: 苹方;
  font-size: 24px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: 0px;
  text-align: left;
  margin: 0 auto;
  transform: translateY(-35px);
}

.txt {
  /* 1．在读大学生、研究生提供学生证，校园卡照片或学信网学历截图进行认证； 2．已毕业老师提供毕业证、学信网学历截图或工作证等进行认证； 3．教师资格证认证后对外会展示老师持有教师资格证，优先接单； 4．若上述资料都没法提供，可提供其他证明，证明老师优秀，有能力带好学生即可； 5．三类证件至少提供一个，方便后台进行审核； */
  width: 527px;
  height: 100px;
  color: rgb(48, 49, 51, 0.8);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
  margin: 0 auto;
  transform: translateY(-20px);
}

.box {
  /* card/off/on */
  width: 421px;
  height: auto;
  box-shadow: 0px 8px 20px rgba(177, 197, 197, 0.2);
  border: 1px solid rgb(228, 231, 237);
  margin: 12px auto;
}

.smalltitle {
  /* 学生证（或毕业证） */
  color: rgb(48, 49, 51);
  font-family: 苹方;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  margin-top: 12px;
  margin-left: 21px;
}

.box .line {
  /* header (style) */
  width: 421px;
  height: 1px;
  background-color: rgb(228, 231, 237);
  margin-top: 12px;
}

.upload-demo {
  margin-top: 13px;
  margin-left: 30px;
  margin-bottom: 10px;
}

/deep/ .el-upload-list__item {
  height: 30px;
}

button {
  width: 90px;
  height: 32px;
  background: rgb(1, 162, 153);
  border-radius: 4px;
  border: none;
  /* Small Button */
  color: rgb(255, 254, 254);
  font-family: Microsoft YaHei;
  font-size: 13px;
  font-weight: 400;
  line-height: 8px;
  letter-spacing: 0px;
  text-align: center;
  margin-left: 395px;
  margin-top: 10px;
  margin-bottom: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/teacherrenzhenging.vue